import React from 'react';
import { Button, Input, DatePicker, message } from 'antd';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login/Login';
import NoPermission from './pages/NoPermission/NoPermission'; // 加载二维码配置页面 无需登录
import FreeService from './pages/Landing/FreeService'; // Load FreeService component
import MainLayout from './components/MainLayout/MainLayout';
import WeComList from './pages/PrivateDomain/WeCom/WeComList';
import EmployeeList from './pages/PrivateDomain/Employees/EmployeeList';
import OrderList from './pages/PrivateDomain/Orders/OrderList';
import CustomerLinksList from './pages/PrivateDomain/CustomerLinks/CustomerLinksList';
import FansList from './pages/PrivateDomain/Fans/FansList';
import IPWhiteList from './pages/IPWhiteList/IPWhiteList';
import IPBlackList from './pages/IPBlackList/IPBlackList';
import { SuiteProvider } from './context/SuiteContext';
import 'antd/dist/reset.css';
import './App.css';

// 简单的鉴权组件
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('user_token');
  return token ? children : <Navigate to="/login" />;
};

// Placeholder components for different routes
const Dashboard = () => <div><h2>数据概览</h2><p>这里是数据概览页面内容...</p></div>;
const Assets = () => <div><h2>资产库</h2><p>这里是资产库页面内容...</p></div>;
const Landing = () => <div><h2>落地页管理</h2><p>这里是落地页管理页面内容...</p></div>;


// ... (keep existing imports)

// Update PrivateDomain to handle sub-routes
const PrivateDomain = () => (
  <Routes>
    <Route path="wecom" element={<WeComList />} />
    <Route path="employees" element={<EmployeeList />} />
    <Route path="orders" element={<OrderList />} />
    <Route path="links_cs" element={<CustomerLinksList />} />
    <Route path="fans" element={<FansList />} />
    <Route path="*" element={<div><h2>私域管理</h2><p>这里是私域管理页面内容...</p></div>} />
  </Routes>
);
// Update Firewall to handle sub-routes
const Firewall = () => (
  <Routes>
    <Route path="whitelist" element={<IPWhiteList />} />
    <Route path="blacklist" element={<IPBlackList />} />
    <Route path="*" element={<div><h2>防水墙</h2><p>这里是防水墙页面内容...</p></div>} />
  </Routes>
);
const Account = () => <div><h2>广告账户</h2><p>这里是广告账户页面内容...</p></div>;

const Home = () => {
  const onClick = () => {
    message.success('你点击了按钮！');
  };

  return (
    <div>
      {/* 这里是主页内容 */}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/get_service/qrcode" element={<NoPermission />} />
        <Route path="/free-service" element={<FreeService />} />

        {/* Wrap all authenticated routes with MainLayout */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <SuiteProvider>
                <MainLayout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/dashboard/*" element={<Dashboard />} />
                    <Route path="/assets/*" element={<Assets />} />
                    <Route path="/landing/*" element={<Landing />} />
                    <Route path="/private/*" element={<PrivateDomain />} />
                    <Route path="/firewall/*" element={<Firewall />} />
                    <Route path="/account/*" element={<Account />} />
                  </Routes>
                </MainLayout>
              </SuiteProvider>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
